import React from 'react';

import Divider from '@mui/material/Divider';
import StackM, { StackProps } from '@mui/material/Stack';

export interface Props extends StackProps {
  /**
   * Elements contained by Tooltip.

   */
  children?: React.ReactNode;
  /**
   * Defines the flex-direction style property. It is applied for all screen sizes.
   */
  direction?: StackProps['direction'];
  /**
   * Defines the space between immediate children in px
   */
  spacing?: number;
  /**
   * Add an element between each child.
   * This needs improving

   */
  divider?: React.ReactNode;
  /**
   * Add an element between each child.
   * This needs improving
   *
   */
  hasDivider?: boolean;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.

   */
  sx?: StackProps['sx'];
}

function Stack(props: Props) {
  let dividerOrientation: 'horizontal' | 'vertical';

  if (props.direction === 'row' || props.direction === 'row-reverse') {
    dividerOrientation = 'vertical';
  } else {
    dividerOrientation = 'horizontal';
  }

  const { hasDivider, ...otherProps } = props;

  return (
    <StackM
      {...otherProps}
      divider={
        hasDivider && <Divider orientation={dividerOrientation} flexItem />
      }
    >
      {props.children}
    </StackM>
  );
}

export default Stack;
